import { useEffect, useState } from 'react';
import { getSessionToken as nexoGetSessionToken } from '@tiendanube/nexo';
import { ApiClient, ApiClientOptions } from '../utils/apiHuappsUtils';
import type { ToastManager } from '../utils/toast.utils';

type Store = { id: string; country?: string };
type NexoClient = Parameters<typeof nexoGetSessionToken>[0];
type GetStoreInfo = (nexo: NexoClient) => Promise<Store>;
type GetSessionToken = (nexo: NexoClient) => Promise<string>;
type GoTo = (path: string) => void;
type ToastLike = ToastManager | undefined;

export const useApiClient = ({
  nexo,
  appSlug,
  appApiBaseUrl,
  huappsApiBaseUrl,
  getStoreInfo,
  getSessionToken,
  goTo,
  toast,
}: {
  nexo: NexoClient;
  appSlug: string;
  appApiBaseUrl: string;
  huappsApiBaseUrl: string;
  getStoreInfo: GetStoreInfo;
  getSessionToken: GetSessionToken;
  goTo: GoTo;
  toast?: ToastLike;
}) => {
  const [AppApi, setAppApi] = useState<ApiClient | null>(null);
  const [HuappsApi, setHuappsApi] = useState<ApiClient | null>(null);
  const [apiLoading, setApiLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const apiBaseOptions: ApiClientOptions = {
        baseUrl: '',
        store: await getStoreInfo(nexo),
        getToken: async () => await getSessionToken(nexo),
        appId: process.env.REACT_APP_REAL_ID as string,
        redirect: (path: string, method: 'goTo' | 'navigate') =>
          method === 'goTo' ? goTo(path) : (window.location.href = path),
        toast,
      };

      const appApiInstance = new ApiClient({
        ...apiBaseOptions,
        baseUrl: appApiBaseUrl,
      });
      const huappsApiInstance = new ApiClient({
        ...apiBaseOptions,
        baseUrl: `${huappsApiBaseUrl}/enhanced/${appSlug}`,
      });

      setAppApi(appApiInstance);
      setHuappsApi(huappsApiInstance);
      setApiLoading(false);
    };
    init();
  }, []);

  return { AppApi, HuappsApi, apiLoading };
};
